"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IR = void 0;
var GameInfo_1 = require("./GameInfo");
exports.IR = {
    Name: 'Imperator: Rome',
    Extension: '.rome',
    Compressed: GameInfo_1.CompressMode.Split,
    MagicNumber: null,
    MagicString: 'IRtxt',
    Dictionary: {},
    FormatRules: [],
    InitiateParser: function () { return; }
};
exports.default = exports.IR;
